(() => {
  if (window.glassiquePurchaseReady) return;
  window.glassiquePurchaseReady = true;
  let queued = false;
  let currentBar;
  let moreSequence = 0;
  const visible = element => !!element && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; refresh(); });
  };
  const updateText = (element, value) => { if (element && element.textContent !== value) element.textContent = value; };
  const bindBundle = (bundle, bar) => {
    const bars = Array.from(bundle.querySelectorAll('.kaching-bundles__bars > .kaching-bundles__bar'));
    if (bars.length < 3) return;
    bundle.classList.add('gq-bundle-compact');
    bars.forEach((offer, index) => { if (index > 1) offer.classList.add('gq-bundle-more'); });
    let toggle = bundle.nextElementSibling;
    if (!toggle?.matches('[data-gq-bundle-toggle]')) {
      toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'gq-bundle-toggle';
      toggle.dataset.gqBundleToggle = '';
      if (!bundle.id) bundle.id = `gq-bundle-${++moreSequence}`;
      toggle.setAttribute('aria-controls', bundle.id);
      toggle.setAttribute('aria-expanded', 'false');
      toggle.textContent = bar.dataset.moreLabel;
      toggle.addEventListener('click', () => {
        const expanded = !bundle.classList.contains('gq-bundle-expanded');
        bundle.classList.toggle('gq-bundle-expanded', expanded);
        toggle.setAttribute('aria-expanded', String(expanded));
        updateText(toggle, expanded ? bar.dataset.lessLabel : bar.dataset.moreLabel);
      });
      bundle.after(toggle);
    }
  };
  const refresh = () => {
    const bar = document.querySelector('[data-gq-purchase]');
    if (!bar) { document.documentElement.classList.remove('gq-purchase-enhanced'); return; }
    const section = bar.closest('.shopify-section--main-product');
    if (!section) return;
    const form = document.getElementById(bar.dataset.formId);
    const nativeAdd = form?.querySelector('buy-buttons button[type="submit"]');
    if (!nativeAdd) return;
    document.documentElement.classList.add('gq-purchase-enhanced');
    const cod = section.querySelector('#custom-button-A');
    const duplicate = section.querySelector('#custom-button-B');
    cod?.closest('.product-info__block-item')?.classList.add('gq-cod-block');
    duplicate?.closest('.product-info__block-item')?.classList.add('gq-payment-duplicate');
    section.querySelectorAll('.product-info kaching-bundle').forEach(bundle => bindBundle(bundle, bar));
    const add = bar.querySelector('[data-gq-purchase-add]');
    const payDelivery = bar.querySelector('[data-gq-purchase-cod]');
    const disabled = nativeAdd.disabled || nativeAdd.getAttribute('aria-disabled') === 'true';
    if (add.disabled !== disabled) add.disabled = disabled;
    payDelivery.hidden = !visible(cod) || cod.disabled;
    if (payDelivery.disabled !== disabled) payDelivery.disabled = disabled;
    const total = form.querySelector('.kaching-bundles-atc-total')?.textContent.replace(/^[\s·]+/, '').trim();
    const currentPrice = section.querySelector('.product-info .price-list sale-price')?.textContent.trim();
    if (total || currentPrice) updateText(bar.querySelector('[data-gq-purchase-price]'), total || currentPrice);
    if (disabled) updateText(add, nativeAdd.textContent.trim());
    else updateText(add, bar.dataset.addLabel || nativeAdd.textContent.replace(/\s*·.*$/, '').trim());
    if (currentBar !== bar) {
      currentBar = bar;
      add.addEventListener('click', () => {
        const freshForm = document.getElementById(bar.dataset.formId);
        const button = freshForm?.querySelector('buy-buttons button[type="submit"]');
        if (button && !button.disabled) button.click();
      });
      payDelivery.addEventListener('click', () => {
        const button = bar.closest('.shopify-section--main-product')?.querySelector('#custom-button-A');
        if (button && !button.disabled) button.click();
      });
    }
    const rect = nativeAdd.getBoundingClientRect();
    const nativeInView = rect.bottom > 80 && rect.top < window.innerHeight;
    const modal = Array.from(document.querySelectorAll('dialog[open],[aria-modal="true"],cart-drawer[open],x-drawer[open],.drawer[open]')).some(visible);
    const keyboard = window.visualViewport && window.visualViewport.height < window.innerHeight * .75;
    bar.hidden = !window.matchMedia('(max-width:699px)').matches || nativeInView || window.scrollY < 200 || modal || !!keyboard;
  };
  addEventListener('scroll', schedule, {passive:true});
  addEventListener('resize', schedule, {passive:true});
  document.addEventListener('variant:change', schedule);
  document.addEventListener('cart:change', schedule);
  document.addEventListener('toggle', schedule, true);
  document.addEventListener('change', schedule, true);
  const start = () => {
    new MutationObserver(schedule).observe(document.body, {childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:['open','disabled','aria-hidden','aria-modal','aria-expanded']});
    schedule();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
